import { RELATED_PARTY_QUESTIONS } from '@funnels/constants';
import { Question } from '@funnels/types';

export function getPPSRelatedPartyDisplayFields(questions: Question[]) {
  const hasTitle = questions.some((q: Question) => q === RELATED_PARTY_QUESTIONS.TITLE);
  const hasFirstName = questions.some((q: Question) => q === RELATED_PARTY_QUESTIONS.FIRST_NAME);
  const hasLastName = questions.some((q: Question) => q === RELATED_PARTY_QUESTIONS.LAST_NAME);
  const hasPhone = questions.some((q: Question) => q === RELATED_PARTY_QUESTIONS.PHONE);
  const hasBusinessName = questions.some((q: Question) => q === RELATED_PARTY_QUESTIONS.BUSINESS_NAME);
  const hasBusinessAddress = questions.some((q: Question) => q === RELATED_PARTY_QUESTIONS.ADDRESS);
  const hasEmail = questions.some((q: Question) => q === RELATED_PARTY_QUESTIONS.EMAIL);

  return {
    hasTitle,
    hasFirstName,
    hasLastName,
    hasPhone,
    hasBusinessName,
    hasBusinessAddress,
    hasEmail,
  };
}
